import styled, { css } from 'styled-components';
import colorfulLine from '@/media/asaas/colorful-border.svg';

export const Card = styled.div`
${({ featured }) => css`
    background-image: ${featured ? `url(${colorfulLine})` : undefined};
    background-size: cover;
    height: auto;
    padding: ${featured ? '4px' : '0px'};
    width: 100%;
  `}
`;

export const Wrapper = styled.div`
  ${({ theme, altLayout }) => css`
    background-color: ${altLayout ? theme.color.indigo : theme.color.white};
    color: ${altLayout ? theme.color.white : theme.color.tundora};
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    font-size: 16px;
    gap: 24px;
    min-height: 337px;
    justify-content: space-between;
    left: 0;
    padding: 16px 24px 24px 24px;
  `}
`;

export const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Logo = styled.img`
  object-fit: scale-down;
`;

export const Tags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;

export const Link = styled.a`
  display: flex;
  flex-direction: column;
  text-decoration: none;
  align-items: center;
`;

export const Description = styled.div`
  ${({ theme, altLayout }) => css`
    color: ${altLayout ? theme.color.white : theme.color.tundora};
    font-size: 14px;
    line-height: 21px;
    font-family: 'Galano';
    font-weight: ${theme.font.weights.regular};
  `}
`;
